:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.faq {
  background-color: #3dcd58;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  margin-bottom: 8px;
}

@media screen and (max-width: 979px) {
  .faq {
    padding: 64px 16px 78px;
  }
}

@media screen and (min-width: 980px) {
  .faq {
    padding: 48px 20px;
  }
}

.faq__heading,
.faq__text {
  text-align: center;
  color: #ffffff;
}

.faq__heading {
  font-weight: 700;
}

@media screen and (max-width: 979px) {
  .faq__heading {
    font-size: 32px;
    line-height: 42px;
    margin: 0 0 16px 0;
  }
}

@media screen and (min-width: 980px) {
  .faq__heading {
    font-size: 40px;
    line-height: 56px;
    margin: 0 0 12px 0;
  }
}

.faq__text {
  font-size: 18px;
  line-height: 30px;
  margin: 0;
}

@media screen and (max-width: 979px) {
  .faq__text {
    margin-bottom: 16px;
  }
}

@media screen and (min-width: 980px) {
  .faq__text {
    margin-bottom: 36px;
  }
}

.faq__button-link {
  display: inline-flex;
  align-items: center;
}

.faq__button-wrapper {
  text-align: center;
}